define.alias("ember-cli-string-helpers/helpers/dasherize", "settings/helpers/dasherize");